<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_313" data-name="Group 313" transform="translate(-35.342 -280.286)">
    <circle id="Ellipse_220" data-name="Ellipse 220" cx="35.201" cy="35.201" r="35.201" transform="translate(35.342 280.286)" fill="#fff"/>
    <path id="Path_444" data-name="Path 444" d="M1201.838,299.174v15.515a9.385,9.385,0,0,1-4.487,8.005v15.118h-8.732V323.247a9.381,9.381,0,0,1-5.54-8.558V304.8a1.529,1.529,0,1,1,3.059,0v7.647h.574v.005a6.872,6.872,0,0,1,6.694,6.651h.8a7.687,7.687,0,0,0-7.036-7.425l-.169-.016V294.9a1.533,1.533,0,0,1,3.065,0v13.045a.43.43,0,1,0,.859,0V293.6a1.532,1.532,0,0,1,3.065,0v14.351a.429.429,0,1,0,.858,0V294.9a1.532,1.532,0,0,1,3.065,0v13.05a.432.432,0,1,0,.864,0v-8.774a1.53,1.53,0,1,1,3.06,0Z" transform="translate(-1133.858)" fill="#1a1818"/>
    <path id="Path_445" data-name="Path 445" d="M1211.281,320.882v7.99a4.83,4.83,0,0,1-2.31,4.122v8.361h-4.5v-8.076a4.83,4.83,0,0,1-2.853-4.407v-5.091a.788.788,0,1,1,1.575,0v3.938h.3v0a3.539,3.539,0,0,1,3.447,3.425h.412a3.958,3.958,0,0,0-3.623-3.824l-.087-.008v-8.633a.789.789,0,0,1,1.579,0V325.4a.221.221,0,1,0,.442,0v-7.391a.789.789,0,1,1,1.578,0V325.4a.221.221,0,1,0,.442,0v-6.721a.789.789,0,0,1,1.579,0V325.4a.223.223,0,1,0,.445,0v-4.518a.787.787,0,1,1,1.575,0Z" transform="translate(-1133.858)" fill="#1a1818"/>
    <path id="Path_446" data-name="Path 446" d="M1212.92,304.312v10.514a6.358,6.358,0,0,0,3.04,5.424v16.588h5.917V320.625a6.359,6.359,0,0,0,3.754-5.8v-6.7a1.037,1.037,0,1,0-2.073,0v5.182h-.389v0a4.657,4.657,0,0,0-4.536,4.508h-.542a5.208,5.208,0,0,1,4.767-5.032l.114-.011V301.418a1.039,1.039,0,0,0-2.077,0v8.84a.291.291,0,1,1-.581,0v-9.725a1.038,1.038,0,0,0-2.077,0v9.725a.291.291,0,1,1-.582,0v-8.843a1.039,1.039,0,0,0-2.077,0v8.843a.292.292,0,0,1-.585,0v-5.946a1.037,1.037,0,1,0-2.073,0Z" transform="translate(-1133.858)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_01_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_01_02.vue